import { onboardTrackingConstants } from '@zola-helpers/client';

const { BUSINESS_UNIT, COMPONENT } = onboardTrackingConstants;

export function mapComponentToBusinessUnit(businessUnitComponent) {
  switch (businessUnitComponent) {
    case COMPONENT.REGISTRY:
      return BUSINESS_UNIT.WEDDING_REGISTRY;
    case COMPONENT.WEDDING_WEBSITE:
    case COMPONENT.WEDDING_CHECKLIST:
    case COMPONENT.WEDDING_PLANNING:
    case COMPONENT.WEDDING_GUEST_LIST:
    case COMPONENT.WEDDINGS:
      return BUSINESS_UNIT.WEDDINGS;
    case COMPONENT.INVITATIONS:
    case COMPONENT.SAVE_THE_DATE:
    case COMPONENT.CHANGE_THE_DATE:
    case COMPONENT.THANK_YOU_CARDS:
    case COMPONENT.DAY_OF_PAPER:
    case COMPONENT.HOLIDAY:
      return BUSINESS_UNIT.INVITATIONS;
    default:
      return BUSINESS_UNIT.WEDDINGS;
  }
}

export function mapCardTypeToBusinessUnitComponent(cardType) {
  switch (cardType) {
    case 'SAVE_THE_DATE':
      return COMPONENT.SAVE_THE_DATE;
    case 'CHANGE_THE_DATE':
      return COMPONENT.CHANGE_THE_DATE;
    case 'THANK_YOU':
      return COMPONENT.THANK_YOU_CARDS;
    case 'MENU':
    case 'PROGRAM':
      return COMPONENT.DAY_OF_PAPER;
    case 'HOLIDAY':
      return COMPONENT.HOLIDAY;
    default:
      return COMPONENT.INVITATIONS;
  }
}

export function preventAndPersist(event) {
  event.preventDefault();
  event.persist();
}

export default {
  mapComponentToBusinessUnit,
  mapCardTypeToBusinessUnitComponent,
  preventAndPersist,
};



// WEBPACK FOOTER //
// ./src/components/onboard/onboardHelpers.js